import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import 'animate.css';
import { Collapse, CollapseItem } from 'vant';
import 'vant/lib/index.css';
Vue.use(ElementUI);
Vue.use(Collapse);
Vue.use(CollapseItem);

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
